import React from 'react';
import { node, object, shape, func, oneOf } from 'prop-types';
import { InstantSearch, Translations } from 'modules';
import {
    Header,
    BrowserHistory,
    LocalStorage,
    FeatureFlags,
    AutoScroll,
    Currency,
    Locale,
    SSRData,
    WishList,
    SponsoredProducts,
} from 'contexts';
import {
    ssrDataShape,
    locationShape,
    searchClientShape,
    searchStateShape,
} from 'shapes';
import { LOCALES } from '../../constants';

export default function App({
    children,
    ssrData,
    resultsState,
    searchClient,
    searchState,
    location,
    translations,
    ...otherProps
}) {
    return (
        <SSRData data={ssrData}>
            <FeatureFlags>
                <SponsoredProducts data={ssrData.sponsoredProductsData}>
                    <Translations
                        platform={ssrData.platform}
                        translations={translations}
                    >
                        <BrowserHistory
                            location={location}
                            paths={['/recherche/:query']}
                        >
                            <Header>
                                <InstantSearch
                                    resultsState={resultsState}
                                    searchClient={searchClient}
                                    initialSearchState={searchState}
                                    {...otherProps}
                                >
                                    <AutoScroll>
                                        <LocalStorage>
                                            <WishList>
                                                <Locale>
                                                    <Currency>
                                                        {children}
                                                    </Currency>
                                                </Locale>
                                            </WishList>
                                        </LocalStorage>
                                    </AutoScroll>
                                </InstantSearch>
                            </Header>
                        </BrowserHistory>
                    </Translations>
                </SponsoredProducts>
            </FeatureFlags>
        </SSRData>
    );
}

App.propTypes = {
    children: node.isRequired,
    ssrData: ssrDataShape,
    /* eslint-disable react/forbid-prop-types */
    resultsState: object,
    /* eslint-enable react/forbid-prop-types */
    location: locationShape,
    searchClient: searchClientShape.isRequired,
    searchState: searchStateShape,
    translations: shape({
        messages: object,
        addLocaleData: func.isRequired,
        locale: oneOf(Object.values(LOCALES)),
    }).isRequired,
};

App.defaultProps = {
    resultsState: undefined,
    ssrData: {},
    location: undefined,
    searchState: {},
};
